var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.54,
    cy: 256,
    fill: "#ffffff",
    rx: 254.54,
    ry: 255.981,
    "data-original": "#b3ceec",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.599 380.628h-50.736c-3.983 0-7.211-3.229-7.211-7.211v-234.834c0-3.983 3.229-7.211 7.211-7.211h50.736c3.983 0 7.211 3.229 7.211 7.211v234.834c0 3.983-3.228 7.211-7.211 7.211z",
    fill: "#000000",
    "data-original": "#5f99d7",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.137 380.628h-50.736c-3.983 0-7.211-3.229-7.211-7.211v-234.834c0-3.983 3.229-7.211 7.211-7.211h50.736c3.983 0 7.211 3.229 7.211 7.211v234.834c0 3.983-3.228 7.211-7.211 7.211z",
    fill: "#000000",
    "data-original": "#5f99d7",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-5.891 0-11.73.217-17.521.609 133.21 9.006 238.479 119.897 238.479 255.391s-105.269 246.385-238.479 255.391c5.791.392 11.63.609 17.521.609 141.385 0 256-114.615 256-256s-114.615-256-256-256z",
    fill: "#ffffff",
    "data-original": "#98bce5",
    style: {},
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.fd87ae25.svg";
export { ForwardRef as ReactComponent };